// extracted by mini-css-extract-plugin
export default {"content":"TechnicalSkillModal_content__YauRi"};